import { H5, H6, Body1 } from '../../Nodes/Typography'
import { formatDate, truncate } from '../../../utilities'

const contentDisplay = (props) => {
    const { content } = props

    return (
        <div className="content-display">
            <div className="content-display__inner">
                <div className="content-display__img" style={{ backgroundImage: `url(${content.image})`}}></div>
                <div className="content-display__body">
                    <H5 className="content-display__body__title">{content.title}</H5>
                    { content.subtitle && <H6 className="content-display__body__subtitle">{content.subtitle}</H6> }
                    <H6 className="content-display__body__publication-date">{formatDate(content.publicationDate)}</H6>                    
                    <Body1 className="constent-display__body__body content-display--hidden" dangerouslySetInnerHTML={{ __html: truncate(content.body, 200) }}/>
                    { content.authors && <H6 className="content-display__body__author content-display--hidden">{content.authors.join(', ')}</H6> }
                </div>
            </div>
        </div>
    )
}

export default contentDisplay
